import { memo } from 'react'

import { Box, HStack, Skeleton, VStack } from 'native-base'

export const SkeletonContentDetailDesktop = memo(() => {
  return (
    <VStack space={4}>
      <Box bg="white" p={6} borderRadius="20px">
        <HStack mb={7} alignItems="center" justifyContent="space-between">
          <HStack alignItems="center" space={6}>
            <Skeleton rounded="full" w="64px" h="24px" />
            <HStack space={4} alignItems="center">
              <Skeleton rounded="4px" w="140px" h="16px" />
              <HStack alignItems="center" space={1}>
                <Skeleton rounded="full" w="16px" h="16px" />
                <Skeleton rounded="4px" w="24px" h="16px" />
              </HStack>
            </HStack>
          </HStack>
          <Skeleton rounded="8px" w="160px" h="36px" />
        </HStack>

        <VStack space={4}>
          <Skeleton w="100%" h="260px" rounded="20px" />
          <VStack space={3}>
            <Skeleton w="80%" h="18px" />
            <Skeleton w="90%" h="18px" />
            <Skeleton w="70%" h="18px" />
          </VStack>
        </VStack>
      </Box>

      <Box bg="white" p={6} borderRadius="20px">
        <HStack alignItems="center" justifyContent="space-between">
          <HStack alignItems="center" space={2}>
            <Skeleton rounded="full" w="20px" h="20px" />
            <Skeleton w="220px" h="18px" />
          </HStack>
          <Skeleton rounded="full" w="20px" h="20px" />
        </HStack>
      </Box>
    </VStack>
  )
})
